export default "__VITE_ASSET__B0w1GcEu__"